import React, { FC, useEffect, useState } from 'react';
import { Form, Modal } from 'antd';
import styles from '../Landing.module.scss';
import { SelectOption } from '../../../AnnotationManager/Annotation/annotation.types';
import SearchItem from '../SearchForm/SearchItem';
import { BulkTurbinesUpdateConfig } from '../Landing.slice';
import { getConfirmText, possibleBulkUpdateStatuses } from '../Helpers';

type Props = {
  showModal: boolean;
  assignees: SelectOption[];
  selectedRowKeys: string[];
  updateIssues: string[];
  onCancel: () => void;
  bulkUpdate: (model: BulkTurbinesUpdateConfig) => void;
  clearBulkUpdateIssues: () => void;
};

export const BulkUpdateModal: FC<Props> = ({ showModal, assignees, updateIssues, selectedRowKeys, onCancel, bulkUpdate, clearBulkUpdateIssues }) => {
  const [assigneeId, setAssigneeId] = useState<string>();
  const [status, setStatus] = useState<string>();

  useEffect(() => {
    if (showModal) {
      setAssigneeId(undefined);
      setStatus(undefined);
    }
  }, [showModal]);

  const onSave = () => {
    const model: BulkTurbinesUpdateConfig = {
      turbinePaths: selectedRowKeys
    };

    if (assigneeId) {
      const assignee = assignees.find(x => x.value === assigneeId);

      model.assigneeId = assigneeId;
      model.assigneeFullName = assignee?.text;
    }

    if (status) {
      model.status = status;
    }

    Modal.confirm({
      title: 'Confirm',
      content: getConfirmText(model),
      okText: 'Yes',
      cancelText: 'No',
      onOk: () => {
        bulkUpdate(model);
      },
      onCancel: () => {
        return;
      }
    });
  };

  const onClose = () => {
    clearBulkUpdateIssues();
    onCancel();
  };

  return (
    <Modal className='bulk-update' title='Bulk Update' cancelText='Close' okText='Save' onOk={onSave} visible={showModal} onCancel={onClose}>
      <Form className={styles.formContainer} layout='vertical'>
        <div className={styles.filterCard}>
          <SearchItem label='Assignee' value={assigneeId} values={assignees} onChange={setAssigneeId} maxWidth='320' />
          <SearchItem label='Action' value={status} values={possibleBulkUpdateStatuses} onChange={setStatus} maxWidth='320' />
          {!!updateIssues.length && (
            <div className={styles.bulkIssues}>
              <h6>Issues:</h6>
              {updateIssues.map(issue => (
                <span>- {issue}</span>
              ))}
            </div>
          )}
        </div>
      </Form>
    </Modal>
  );
};

export default BulkUpdateModal;
